export const antarctic = [
  {
    name: { common: 'Antarctica', official: 'Antarctica' },
    tld: ['.aq'],
    cca2: 'AQ',
    ccn3: '010',
    cca3: 'ATA',
    independent: false,
    status: 'officially-assigned',
    unMember: false,
    idd: {},
    altSpellings: ['AQ'],
    region: 'Antarctic',
    translations: {
      ara: { official: 'أنتارتيكا', common: 'أنتارتيكا' },
      bre: { official: 'Antarktika', common: 'Antarktika' },
      ces: { official: 'Antarktida', common: 'Antarktida' },
      cym: { official: 'Yr Antarctig', common: 'Yr Antarctig' },
      deu: { official: 'Antarktika', common: 'Antarktis' },
      est: { official: 'Antarktika', common: 'Antarktika' },
      fin: { official: 'Etelämanner', common: 'Etelämanner' },
      fra: { official: 'Antarctique', common: 'Antarctique' },
      hrv: { official: 'Antarktika', common: 'Antarktika' },
      hun: { official: 'Antarktisz', common: 'Antarktisz' },
      ita: { official: 'Antartide', common: 'Antartide' },
      jpn: { official: '南極大陸', common: '南極' },
      kor: { official: '남극', common: '남극' },
      nld: { official: 'Antarctica', common: 'Antarctica' },
      per: { official: 'جنوبگان', common: 'جنوبگان' },
      pol: { official: 'Antarktyka', common: 'Antarktyka' },
      por: { official: 'Antártica', common: 'Antártida' },
      rus: { official: 'Антарктида', common: 'Антарктида' },
      slk: { official: 'Antarktída', common: 'Antarktída' },
      spa: { official: 'Antártida', common: 'Antártida' },
      swe: { official: 'Antarktis', common: 'Antarktis' },
      tur: { official: 'Antarktika', common: 'Antarktika' },
      urd: { official: 'انٹارکٹکا', common: 'انٹارکٹکا' },
      zho: { official: '南极洲', common: '南极洲' }
    },
    latlng: [-90.0, 0.0],
    landlocked: false,
    area: 1.4e7,
    demonyms: {
      eng: { f: 'Antarctican', m: 'Antarctican' },
      fra: { f: 'Antarcticaine', m: 'Antarcticain' }
    },
    flag: '\uD83C\uDDE6\uD83C\uDDF6',
    maps: {
      googleMaps: 'https://goo.gl/maps/kyBuJriu4itiXank7',
      openStreetMaps: 'https://www.openstreetmap.org/node/36966060'
    },
    population: 1000,
    car: { signs: [''], side: 'right' },
    timezones: [
      'UTC-03:00',
      'UTC+03:00',
      'UTC+05:00',
      'UTC+06:00',
      'UTC+07:00',
      'UTC+08:00',
      'UTC+10:00',
      'UTC+12:00'
    ],
    continents: ['Antarctica'],
    flags: {
      png: 'https://flagcdn.com/w320/aq.png',
      svg: 'https://flagcdn.com/aq.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/aq.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/aq.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: {}
  },
  {
    name: {
      common: 'South Georgia',
      official: 'South Georgia and the South Sandwich Islands',
      nativeName: {
        eng: {
          official: 'South Georgia and the South Sandwich Islands',
          common: 'South Georgia'
        }
      }
    },
    tld: ['.gs'],
    cca2: 'GS',
    ccn3: '239',
    cca3: 'SGS',
    independent: false,
    status: 'officially-assigned',
    unMember: false,
    currencies: { SHP: { name: 'Saint Helena pound', symbol: '£' } },
    idd: { root: '+5', suffixes: ['00'] },
    capital: ['King Edward Point'],
    altSpellings: ['GS', 'South Georgia and the South Sandwich Islands'],
    region: 'Antarctic',
    languages: { eng: 'English' },
    translations: {
      ara: {
        official: 'جورجيا الجنوبية وجزر ساندوتش الجنوبية',
        common: 'جورجيا الجنوبية'
      },
      bre: {
        official: 'Georgia ar Su hag Inizi Sandwich ar Su',
        common: 'Georgia ar Su hag Inizi Sandwich ar Su'
      },
      ces: {
        official: 'Jižní Georgie a Jižní Sandwichovy ostrovy',
        common: 'Jižní Georgie a Jižní Sandwichovy ostrovy'
      },
      cym: {
        official: 'South Georgia and the South Sandwich Islands',
        common: 'South Georgia'
      },
      deu: {
        official: 'Südgeorgien und die Südlichen Sandwichinseln',
        common: 'Südgeorgien und die Südlichen Sandwichinseln'
      },
      est: {
        official: 'Lõuna-Georgia ja Lõuna-Sandwichi saared',
        common: 'Lõuna-Georgia ja Lõuna-Sandwichi saared'
      },
      fin: {
        official: 'Etelä-Georgia ja Eteläiset Sandwichsaaret',
        common: 'Etelä-Georgia ja Eteläiset Sandwichsaaret'
      },
      fra: {
        official: 'Géorgie du Sud et les îles Sandwich du Sud',
        common: 'Géorgie du Sud-et-les Îles Sandwich du Sud'
      },
      hrv: {
        official: 'Južna Džordžija i Otoci Južni Sendvič',
        common: 'Južna Georgija i otočje Južni Sandwich'
      },
      hun: {
        official: 'Déli-Georgia és Déli-Sandwich-szigetek',
        common: 'Déli-Georgia és Déli-Sandwich-szigetek'
      },
      ita: {
        official: 'Georgia del Sud e isole Sandwich del Sud',
        common: 'Georgia del Sud e Isole Sandwich Meridionali'
      },
      jpn: {
        official: 'サウスジョージア·サウスサンドウィッチ諸島',
        common: 'サウスジョージア・サウスサンドウィッチ諸島'
      },
      kor: { official: '조지아', common: '조지아' },
      nld: {
        official: 'Zuid-Georgië en de Zuidelijke Sandwich-eilanden',
        common: 'Zuid-Georgia en Zuidelijke Sandwicheilanden'
      },
      per: {
        official: 'جزایر جورجیای جنوبی و ساندویچ جنوبی',
        common: 'جزایر جورجیای جنوبی و ساندویچ جنوبی'
      },
      pol: {
        official: 'Georgia Południowa i Sandwich Południowy',
        common: 'Georgia Południowa i Sandwich Południowy'
      },
      por: {
        official: 'Geórgia do Sul e Sandwich do Sul',
        common: 'Ilhas Geórgia do Sul e Sandwich do Sul'
      },
      rus: {
        official: 'Южная Георгия и Южные Сандвичевы острова',
        common: 'Южная Георгия и Южные Сандвичевы острова'
      },
      slk: {
        official: 'Južná Georgia a Južné Sandwichove ostrovy',
        common: 'Južná Georgia a Južné Sandwichove ostrovy'
      },
      spa: {
        official: 'Georgia del Sur y las Islas Sandwich del Sur',
        common: 'Islas Georgias del Sur y Sandwich del Sur'
      },
      swe: { official: 'Sydgeorgien', common: 'Sydgeorgien' },
      tur: {
        official: 'Güney Georgia ve Güney Sandwich Adaları',
        common: 'Güney Georgia ve Güney Sandwich Adaları'
      },
      urd: {
        official: 'جنوبی جارجیا و جزائر جنوبی سینڈوچ',
        common: 'جنوبی جارجیا'
      },
      zho: { official: '南乔治亚岛和南桑威奇群岛', common: '南乔治亚' }
    },
    latlng: [-54.5, -37.0],
    landlocked: false,
    area: 3903.0,
    demonyms: {
      eng: {
        f: 'South Georgian South Sandwich Islander',
        m: 'South Georgian South Sandwich Islander'
      }
    },
    flag: '\uD83C\uDDEC\uD83C\uDDF8',
    maps: {
      googleMaps: 'https://goo.gl/maps/mJzdaBwKBbm2B81q9',
      openStreetMaps: 'https://www.openstreetmap.org/relation/1983629'
    },
    population: 30,
    car: { signs: [''], side: 'right' },
    timezones: ['UTC-02:00'],
    continents: ['Antarctica'],
    flags: {
      png: 'https://flagcdn.com/w320/gs.png',
      svg: 'https://flagcdn.com/gs.svg'
    },
    coatOfArms: {},
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-54.28, -36.5] }
  },
  {
    name: {
      common: 'Bouvet Island',
      official: 'Bouvet Island',
      nativeName: {
        nor: { official: 'Bouvetøya', common: 'Bouvetøya' }
      }
    },
    tld: ['.bv'],
    cca2: 'BV',
    ccn3: '074',
    cca3: 'BVT',
    independent: false,
    status: 'officially-assigned',
    unMember: false,
    idd: { root: '+4', suffixes: ['7'] },
    altSpellings: ['BV', 'Bouvetøya', 'Bouvet-øya'],
    region: 'Antarctic',
    languages: { nor: 'Norwegian' },
    translations: {
      ara: { official: 'جزر بوفيه', common: 'جزر بوفيه' },
      bre: { official: 'Enez Bouvet', common: 'Enez Bouvet' },
      ces: { official: 'Bouvetův ostrov', common: 'Bouvetův ostrov' },
      cym: { official: 'Bouvet Island', common: 'Bouvet Island' },
      deu: { official: 'Bouvetinsel', common: 'Bouvetinsel' },
      est: { official: 'Bouvet’ saar', common: 'Bouvet’ saar' },
      fin: { official: "Bouvet'nsaari", common: "Bouvet'nsaari" },
      fra: { official: 'Île Bouvet', common: 'Île Bouvet' },
      hrv: { official: 'Bouvet Island', common: 'Otok Bouvet' },
      hun: { official: 'Bouvet-sziget', common: 'Bouvet-sziget' },
      ita: { official: 'Isola Bouvet', common: 'Isola Bouvet' },
      jpn: { official: 'ブーヴェ島', common: 'ブーベ島' },
      kor: { official: '부베 섬', common: '부베 섬' },
      nld: { official: 'Bouvet Island', common: 'Bouveteiland' },
      per: { official: 'جزیرهٔ بووه', common: 'جزیرهٔ بووه' },
      pol: { official: 'Wyspa Bouveta', common: 'Wyspa Bouveta' },
      por: { official: 'Ilha Bouvet', common: 'Ilha Bouvet' },
      rus: { official: 'Остров Буве', common: 'Остров Буве' },
      slk: { official: 'Bouvetov ostrov', common: 'Bouvetov ostrov' },
      spa: { official: 'Isla Bouvet', common: 'Isla Bouvet' },
      swe: { official: 'Bouvetön', common: 'Bouvetön' },
      tur: { official: 'Bouvet Adası', common: 'Bouvet Adası' },
      urd: { official: 'جزیرہ بووہ', common: 'جزیرہ بووہ' },
      zho: { official: '布维岛', common: '布维岛' }
    },
    latlng: [-54.43333333, 3.4],
    landlocked: false,
    area: 49.0,
    flag: '\uD83C\uDDE7\uD83C\uDDFB',
    maps: {
      googleMaps: 'https://goo.gl/maps/7WRQAEKZb4uK36yi9',
      openStreetMaps: 'https://www.openstreetmap.org/way/174996681'
    },
    population: 0,
    car: { signs: [''], side: 'right' },
    timezones: ['UTC+01:00'],
    continents: ['Antarctica'],
    flags: {
      png: 'https://flagcdn.com/w320/bv.png',
      svg: 'https://flagcdn.com/bv.svg'
    },
    coatOfArms: {},
    startOfWeek: 'monday',
    capitalInfo: {}
  },
  {
    name: {
      common: 'Heard Island and McDonald Islands',
      official: 'Heard Island and McDonald Islands',
      nativeName: {
        eng: {
          official: 'Heard Island and McDonald Islands',
          common: 'Heard Island and McDonald Islands'
        }
      }
    },
    tld: ['.hm', '.aq'],
    cca2: 'HM',
    ccn3: '334',
    cca3: 'HMD',
    independent: false,
    status: 'officially-assigned',
    unMember: false,
    idd: {},
    altSpellings: ['HM', 'Heard Island and McDonald Islands'],
    region: 'Antarctic',
    languages: { eng: 'English' },
    translations: {
      ara: {
        official: 'جزيرة هيرد وجزر ماكدونالد',
        common: 'جزيرة هيرد وجزر ماكدونالد'
      },
      bre: {
        official: 'Enez Heard hag Inizi McDonald',
        common: 'Inizi Heard ha McDonald'
      },
      ces: {
        official: 'Heardův ostrov a McDonaldovy ostrovy',
        common: 'Heardův ostrov a McDonaldovy ostrovy'
      },
      cym: {
        official: 'Heard Island and McDonald Islands',
        common: 'Heard Island and McDonald Islands'
      },
      deu: {
        official: 'Heard und McDonaldinseln',
        common: 'Heard und die McDonaldinseln'
      },
      est: {
        official: 'Heardi ja McDonaldi saarte ala',
        common: 'Heard ja McDonald'
      },
      fin: {
        official: 'Heard ja McDonaldinsaaret',
        common: 'Heard ja McDonaldinsaaret'
      },
      fra: {
        official: 'Des îles Heard et McDonald',
        common: 'Îles Heard-et-MacDonald'
      },
      hrv: {
        official: 'Otok Heard i otočje McDonald',
        common: 'Otok Heard i otočje McDonald'
      },
      hun: {
        official: 'Heard-sziget és McDonald-szigetek',
        common: 'Heard-sziget és McDonald-szigetek'
      },
      ita: {
        official: 'Isole Heard e McDonald',
        common: 'Isole Heard e McDonald'
      },
      jpn: {
        official: 'ハード島とマクドナルド諸島',
        common: 'ハード島とマクドナルド諸島'
      },
      kor: {
        official: '허드 맥도널드 제도',
        common: '허드 맥도널드 제도'
      },
      nld: {
        official: 'Heard en McDonaldeilanden',
        common: 'Heard-en McDonaldeilanden'
      },
      per: {
        official: 'جزیره هرد و جزایر مک‌دونالد',
        common: 'جزیره هرد و جزایر مک‌دونالد'
      },
      pol: {
        official: 'Terytorium Wysp Heard i McDonalda',
        common: 'Wyspy Heard i McDonalda'
      },
      por: {
        official: 'Ilha Heard e Ilhas McDonald',
        common: 'Ilha Heard e Ilhas McDonald'
      },
      rus: {
        official: 'Остров Херд и острова Макдональд',
        common: 'Остров Херд и острова Макдональд'
      },
      slk: {
        official: 'Teritórium Heardovho ostrova a Macdonaldových ostrovov',
        common: 'Heardov ostrov'
      },
      spa: {
        official: 'Islas Heard y McDonald',
        common: 'Islas Heard y McDonald'
      },
      swe: {
        official: 'Heard- och McDonaldöarna',
        common: 'Heard- och McDonaldöarna'
      },
      tur: {
        official: 'Heard Adası ve McDonald Adaları',
        common: 'Heard Adası ve McDonald Adaları'
      },
      urd: {
        official: 'جزیرہ ہرڈ و جزائر مکڈونلڈ',
        common: 'جزیرہ ہرڈ و جزائر مکڈونلڈ'
      },
      zho: {
        official: '赫德岛和麦当劳群岛',
        common: '赫德岛和麦当劳群岛'
      }
    },
    latlng: [-53.1, 72.51666666],
    landlocked: false,
    area: 412.0,
    demonyms: {
      eng: {
        f: 'Heard and McDonald Islander',
        m: 'Heard and McDonald Islander'
      }
    },
    flag: '\uD83C\uDDED\uD83C\uDDF2',
    maps: {
      googleMaps: 'https://goo.gl/maps/k5FBAiVaVyozuYeA7',
      openStreetMaps: 'https://www.openstreetmap.org/relation/2177227'
    },
    population: 0,
    car: { signs: [''], side: 'right' },
    timezones: ['UTC+05:00'],
    continents: ['Antarctica'],
    flags: {
      png: 'https://flagcdn.com/w320/hm.png',
      svg: 'https://flagcdn.com/hm.svg'
    },
    coatOfArms: {},
    startOfWeek: 'monday',
    capitalInfo: {}
  },
  {
    name: {
      common: 'French Southern and Antarctic Lands',
      official: 'Territory of the French Southern and Antarctic Lands',
      nativeName: {
        fra: {
          official:
            'Territoire des Terres australes et antarctiques françaises',
          common: 'Terres australes et antarctiques françaises'
        }
      }
    },
    tld: ['.tf'],
    cca2: 'TF',
    ccn3: '260',
    cca3: 'ATF',
    independent: false,
    status: 'officially-assigned',
    unMember: false,
    currencies: { EUR: { name: 'Euro', symbol: '€' } },
    idd: { root: '+2', suffixes: ['62'] },
    capital: ['Port-aux-Français'],
    altSpellings: ['TF', 'French Southern Territories'],
    region: 'Antarctic',
    languages: { fra: 'French' },
    translations: {
      ara: {
        official: 'مقاطعات وأقاليم ما وراء البحار الفرنسية',
        common: 'أراض فرنسية جنوبية وأنتارتيكية'
      },
      bre: {
        official: 'Tiriad Douaroù Aostral hag Antarktikel Frañs',
        common: 'Douaroù Aostral hag Antarktikel Frañs'
      },
      ces: {
        official: 'Teritorium Francouzská jižní a antarktická území',
        common: 'Francouzská jižní a antarktická území'
      },
      cym: {
        official: 'Territory of the French Southern and Antarctic Lands',
        common: 'French Southern and Antarctic Lands'
      },
      deu: {
        official: 'Gebiet der Französisch Süd- und Antarktisgebiete',
        common: 'Französische Süd- und Antarktisgebiete'
      },
      est: {
        official: 'Prantsuse Lõunaalad',
        common: 'Prantsuse Lõunaalad'
      },
      fin: {
        official: 'Ranskan eteläiset ja antarktiset alueet',
        common: 'Ranskan eteläiset ja antarktiset alueet'
      },
      fra: {
        official: 'Territoire des Terres australes et antarctiques françaises',
        common: 'Terres australes et antarctiques françaises'
      },
      hrv: {
        official: 'Teritoriju Francuski južni i antarktički teritoriji',
        common: 'Francuski južni i antarktički teritoriji'
      },
      hun: {
        official: 'Francia déli és antarktiszi területek',
        common: 'Francia déli és antarktiszi területek'
      },
      ita: {
        official: 'Territorio della australi e antartiche francesi Terre',
        common: 'Territori Francesi del Sud'
      },
      jpn: {
        official: 'フランス領南方·南極地域の領土',
        common: 'フランス領南方・南極地域'
      },
      kor: {
        official: '프랑스령 남부와 남극 지역',
        common: '프랑스령 남부와 남극 지역'
      },
      nld: {
        official:
          'Grondgebied van de Franse Zuidelijke en Antarctische gebieden',
        common: 'Franse Gebieden in de zuidelijke Indische Oceaan'
      },
      per: {
        official: 'سرزمین‌های جنوبی و جنوبگانی فرانسه',
        common: 'سرزمین‌های جنوبی و جنوبگانی فرانسه'
      },
      pol: {
        official: 'Francuskie Terytoria Południowe i Antarktyczne',
        common: 'Francuskie Terytoria Południowe i Antarktyczne'
      },
      por: {
        official: 'Território do Sul e Antártica Francesa',
        common: 'Terras Austrais e Antárticas Francesas'
      },
      rus: {
        official: 'Территория Французские Южные и Антарктические земли',
        common: 'Французские Южные и Антарктические территории'
      },
      slk: {
        official: 'Francúzske južné a antarktické územia',
        common: 'Francúzske juŽné a antarktické územia'
      },
      spa: {
        official: 'Territorio del Francés Tierras australes y antárticas',
        common: 'Tierras Australes y Antárticas Francesas'
      },
      swe: {
        official: 'Franska syd- och Antarktisterritorierna',
        common: 'Franska södra territorierna'
      },
      tur: {
        official: 'Fransız Güney ve Antarktika Toprakları',
        common: 'Fransız Güney ve Antarktika Toprakları'
      },
      urd: {
        official: 'سرزمینِ جنوبی فرانسیسیہ و انٹارکٹیکہ',
        common: 'سرزمین جنوبی فرانسیسیہ و انٹارکٹیکا'
      },
      zho: {
        official: '法国南部和南极土地',
        common: '法国南部和南极土地'
      }
    },
    latlng: [-49.25, 69.167],
    landlocked: false,
    area: 7747.0,
    demonyms: {
      eng: { f: 'French', m: 'French' },
      fra: { f: 'Française', m: 'Français' }
    },
    flag: '\uD83C\uDDF9\uD83C\uDDEB',
    maps: {
      googleMaps: 'https://goo.gl/maps/6ua6CX1m4w1xF2Em7',
      openStreetMaps: 'https://www.openstreetmap.org/relation/2186658'
    },
    population: 400,
    car: { signs: [''], side: 'right' },
    timezones: ['UTC+05:00'],
    continents: ['Antarctica'],
    flags: {
      png: 'https://flagcdn.com/w320/tf.png',
      svg: 'https://flagcdn.com/tf.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/tf.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/tf.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [48.81, -1.4] }
  }
]
